"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = exports.InputType = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var TextField_1 = tslib_1.__importDefault(require("@material-ui/core/TextField"));
var InputField_style_1 = require("./InputField.style");
var core_1 = require("@material-ui/core");
var InputType;
(function (InputType) {
    InputType["Text"] = "text";
    InputType["Password"] = "password";
    InputType["Email"] = "email";
    InputType["Number"] = "number";
    InputType["Phone"] = "tel";
    InputType["Url"] = "url";
    InputType["File"] = "file";
})(InputType = exports.InputType || (exports.InputType = {}));
var InputField = function (_a) {
    var multiline = _a.multiline, rows = _a.rows, label = _a.label, name = _a.name, placeholder = _a.placeholder, maxLength = _a.maxLength, value = _a.value, validation = _a.validation, required = _a.required, disabled = _a.disabled, _b = _a.isTable, isTable = _b === void 0 ? false : _b, onChange = _a.onChange, onBlur = _a.onBlur, onKeyPress = _a.onKeyPress, _c = _a.type, type = _c === void 0 ? InputType.Text : _c, classes = _a.classes, InputLabelProps = _a.InputLabelProps, InputProps = _a.InputProps, inputProps = _a.inputProps, id = _a.id, startIcon = _a.startIcon, _d = _a.autoComplete, autoComplete = _d === void 0 ? undefined : _d, inputRef = _a.inputRef;
    var defaultClasses = (0, InputField_style_1.useInputFieldStyles)(isTable);
    var styles = classes
        ? tslib_1.__assign(tslib_1.__assign({}, defaultClasses), classes) : defaultClasses;
    var DEFAULT_MAX_LENGTH = 9999;
    return (react_1.default.createElement(TextField_1.default, { inputRef: inputRef, type: type, multiline: multiline, rows: rows, label: label, name: name, id: id || name, placeholder: placeholder, InputLabelProps: tslib_1.__assign({ shrink: true, classes: {
                root: styles.inputLabel,
                shrink: styles.inputLabelShrink,
                focused: styles.inputLabelFocused,
                asterisk: styles.inputLabelRequiredDecorator,
            }, error: false }, InputLabelProps), InputProps: tslib_1.__assign(tslib_1.__assign({ classes: {
                root: styles.inputBase,
                focused: styles.inputBaseFocused,
                disabled: styles.inputBaseDisabled,
                input: styles.input,
                error: styles.inputBaseError,
            } }, InputProps), { startAdornment: startIcon && (react_1.default.createElement(core_1.InputAdornment, { "data-signa": "adornment-icon-start-".concat(name), classes: { positionStart: styles.startInputAdornment }, position: "start" }, startIcon)) }), FormHelperTextProps: {
            classes: {
                root: styles.errorHelperText,
            },
            error: false,
        }, inputProps: tslib_1.__assign(tslib_1.__assign({ maxLength: maxLength ? maxLength : DEFAULT_MAX_LENGTH, 'data-signa': "input-field-".concat(name) }, inputProps), { autoComplete: autoComplete }), error: !!(validation && validation.isError), helperText: validation && validation.isError && validation.message, required: required, disabled: disabled, onChange: onChange, onBlur: onBlur, onKeyPress: onKeyPress, fullWidth: true, variant: "outlined", value: value }));
};
exports.InputField = InputField;
